/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

export type GetApiSentSmsListSortDirection = typeof GetApiSentSmsListSortDirection[keyof typeof GetApiSentSmsListSortDirection] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiSentSmsListSortDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;
